<template>
  <div
    class="queue-list-item-container"
    :class="{ 'is-editing': isCurrentlyGettingEdited }"
  >
    <div class="item-content">
      <!-- CLEAR TIME LABEL -->
      <div class="item-text" :class="{ 'switch-all': item?.isSwitchAll }">
        {{ item?.label }}
      </div>
      <!-- CLEAR TIME LABEL -->

      <!-- CLEAR TIME -->
      <div v-if="notSwitchAllListItem" class="item-text">
        {{ item?.time }}
      </div>
      <!-- CLEAR TIME -->

      <!-- RECURRENCES -->
      <div v-if="notSwitchAllListItem">
        <div class="item-text">
          {{ scheduledRecurrences }}
        </div>
      </div>
      <!-- RECURRENCES -->
    </div>

    <div class="item-actions">
      <!-- EDIT ICON -->
      <div
        v-if="notSwitchAllListItem"
        role="button"
        :class="`edit-icon ${isCurrentlyGettingEdited ? 'is-editing' : ''}`"
        :aria-label="`Edit ${item?.label}`"
        @click="$emit('edit', item)"
      >
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          role="img"
          aria-labelledby="Edit icon"
        >
          <path
            d="M17.5984 9.59844L14.3984 6.39844"
            stroke="currentColor"
            stroke-width="1.2"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M8 19.2L4 20L4.8 16L16.8 4L20 7.2L8 19.2Z"
            stroke="currentColor"
            stroke-width="1.2"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
      </div>
      <!-- EDIT ICON -->

      <!-- DELETE ICON -->
      <IconButton
        v-if="notSwitchAllListItem"
        icon="ri-delete-bin-line delete-icon"
        class="delete-icon"
        :class="{
          'not-allowed': isCurrentlyGettingEdited
        }"
        :aria-label="`Delete ${item?.label}`"
        @click="onDeleteItem"
      />
      <!-- DELETE ICON -->

      <!-- TOGGLE SWITCH -->
      <div
        class="switch-container"
        :class="{
          'not-allowed': isCurrentlyGettingEdited
        }"
      >
        <CustomSwitch :model-value="item?.status" @change="onToggleItem" />
      </div>
      <!-- TOGGLE SWITCH -->
    </div>
  </div>
</template>

<script>
import useConfirmation from "@/composables/useConfirmation"
import IconButton from "@/v3components/shared/Buttons/IconButton.vue"
import CustomSwitch from "@/v3components/shared/Form/CustomSwitch.vue"
import { computed, inject } from "vue"

export default {
  name: "ClearTimeListItem",
  components: {
    CustomSwitch,
    IconButton
  },
  props: {
    item: {
      type: Object,
      default: () => ({})
    },
    isCurrentlyGettingEdited: {
      type: Boolean,
      default: false
    }
  },
  emits: ["delete", "toggle", "edit"],
  setup(props, { emit }) {
    const modal = inject("modal")

    const notSwitchAllListItem = computed(() => {
      return Boolean(props?.item?.isSwitchAll || false) === false
    })

    const scheduledRecurrences = computed(() => {
      const dayMap = {
        MONDAY: "Mon",
        TUESDAY: "Tue",
        WEDNESDAY: "Wed",
        THURSDAY: "Thu",
        FRIDAY: "Fri",
        SATURDAY: "Sat",
        SUNDAY: "Sun"
      }
      return (
        props.item?.recurrence
          ?.filter((recurrence) => Number(recurrence?.status) === 1)
          ?.map(
            (recurrence) =>
              dayMap?.[recurrence?.day?.trim()?.toUpperCase()] || ""
          )
          ?.filter((day) => day !== "")
          ?.join(", ") || "No Recurrences"
      )
    })

    const onDeleteItem = async () => {
      if (props.isCurrentlyGettingEdited) {
        return
      }

      const { showConfirmation } = useConfirmation(modal)
      const confimed = await showConfirmation({
        heading: "Please confirm",
        headingIcon: "ri ri-alert-line",
        headingColor: "red",
        headerPlacement: "start",
        body: `Are you sure you want to remove "${props.item.time}, ${props.item.label}" from the clear time list?`,
        confirmButtonText: "Confirm",
        cancelButtonText: "Cancel",
        cancelButtonSolid: false,
        buttonPlacement: "end"
      })

      if (!confimed) {
        return
      }

      emit("delete", props.item)
    }

    const onToggleItem = () => {
      if (props.isCurrentlyGettingEdited) {
        return
      }
      emit("toggle", props.item)
    }

    return {
      notSwitchAllListItem,
      scheduledRecurrences,
      onDeleteItem,
      onToggleItem
    }
  }
}
</script>
